import React from 'react';

import { Tag } from 'primereact/tag';

import { ActionTypeEnum, LogsItem } from '../../../types/interfaces';

interface ActionDescriptionTagProps {
  rowData: LogsItem;
}

export const ActionDescriptionTag: React.FC<ActionDescriptionTagProps> = ({
  rowData
}) => {
  const isShift = rowData.actionType <= ActionTypeEnum.GENERATION;
  const isAbsence =
    rowData.actionType === ActionTypeEnum.CREATEABSENCE ||
    rowData.actionType === ActionTypeEnum.UPDATEABSENCE ||
    rowData.actionType === ActionTypeEnum.DELETEABSENCE;
  const isTask =
    rowData.actionType === ActionTypeEnum.CREATETASK ||
    rowData.actionType === ActionTypeEnum.DEPARTMENTCHANGEDINTASK ||
    rowData.actionType === ActionTypeEnum.PERSONCHANGEDINTASK ||
    rowData.actionType === ActionTypeEnum.DELETETASK;

  const typeLabel = isShift
    ? 'смен'
    : isAbsence
      ? 'отсутствий'
      : isTask
        ? 'нарядов'
        : 'отсутствий';
  const addedCount = Array.isArray(rowData.added)
    ? rowData.added.length
    : rowData.added
      ? 1
      : 0;
  const deletedCount = Array.isArray(rowData.deleted)
    ? rowData.deleted.length
    : rowData.deleted
      ? 1
      : 0;

  let actionLabel = '';
  let severity: 'info' | 'danger' | 'success' = 'info';

  switch (rowData.actionType) {
  case ActionTypeEnum.CREATE:
  case ActionTypeEnum.CREATEABSENCE:
    actionLabel = `Добавлено ${typeLabel}`;
    severity = 'info';
    break;
  case ActionTypeEnum.CREATETASK:
    actionLabel = 'Добавлен наряд';
    severity = 'info';
    break;
  case ActionTypeEnum.UPDATE:
  case ActionTypeEnum.UPDATEABSENCE:
    actionLabel = `Обновлено ${typeLabel}`;
    severity = 'success';
    break;
  case ActionTypeEnum.DELETE:
  case ActionTypeEnum.DELETEABSENCE:
    actionLabel = `Удалено ${typeLabel}`;
    severity = 'danger';
    break;
  case ActionTypeEnum.DELETETASK:
    actionLabel = 'Удалено нарядов';
    severity = 'danger';
    break;
  case ActionTypeEnum.GENERATION:
    actionLabel = 'Сгенерировано смен';
    severity = 'info';
    break;
  case ActionTypeEnum.DEPARTMENTCHANGEDINTASK:
    actionLabel = 'Изменен участок в наряде';
    severity = 'success';
    break;
  case ActionTypeEnum.PERSONCHANGEDINTASK:
    actionLabel = 'Изменены исполнители в наряде';
    severity = 'success';
    break;
  default:
    actionLabel = 'Неизвестное действие';
    severity = 'info';
  }

  return (
    <div className="flex align-items-center gap-2">
      <Tag
        severity={severity}
        value={
          addedCount > 0 || deletedCount > 0
            ? `${actionLabel}: ${addedCount || deletedCount}`
            : actionLabel
        }
        className="mr-2"
      />
    </div>
  );
};
